module.exports = __webpack_public_path__ + "img/firebridge.45654f61.png";